export default function HowToRegister() {
  return (
    <section id="how-to-register" className="py-16 sm:py-20 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight px-2">
            How to Register &amp; Pay
          </h2>
          <p className="text-base sm:text-lg text-gray-600 px-4">
            Register for the Post-PGA Show event at Alaqua CC
          </p>
        </div>

        {/* Registration Option */}
        <div className="max-w-2xl mx-auto mb-12 sm:mb-16">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm border-2 border-emerald-500">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-emerald-100 rounded-full mb-4 sm:mb-6 mx-auto">
              <i className="ri-team-line text-2xl sm:text-3xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 text-center leading-tight">
              Register for Alaqua CC
            </h3>
            <p className="text-sm sm:text-base text-gray-600 text-center mb-3 sm:mb-4">
              January 23rd, 2026 - 10am Tee Times
            </p>
            <p className="text-sm sm:text-base text-gray-600 text-center mb-4 sm:mb-6">
              Register up to 12 players at once
            </p>
            <p className="text-2xl sm:text-3xl font-bold text-emerald-600 text-center mb-4 sm:mb-6">
              $225 <span className="text-base sm:text-lg text-gray-600">per player</span>
            </p>
            <a
              href="#register-multiple"
              className="block w-full bg-emerald-600 text-white py-3 px-6 rounded-md text-center text-base sm:text-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Register Now
            </a>
          </div>
        </div>

        <div className="mb-10 sm:mb-12">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 sm:mb-8 text-center leading-tight px-2">
            Registration Process
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold mb-4 sm:mb-6">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 leading-tight">
                Enter Player Details
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                Upload a CSV file or manually enter player information. You can register up to 12 players at once.
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold mb-4 sm:mb-6">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 leading-tight">
                Choose Number of Players
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                Select how many players you're paying for. The total will be calculated at <strong>$225 per player</strong>.
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold mb-4 sm:mb-6">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 leading-tight">
                Pay Securely
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                Complete your registration by paying securely via <strong>Stripe</strong>. You'll be redirected to the secure payment page.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-emerald-600 text-white rounded-lg p-6 sm:p-8 text-center">
          <i className="ri-shield-check-line text-4xl sm:text-5xl mb-3 sm:mb-4"></i>
          <h3 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-3 leading-tight">
            Secure Payment Processing
          </h3>
          <p className="text-sm sm:text-base text-emerald-50 max-w-2xl mx-auto leading-relaxed">
            All payments are processed securely through Stripe. Your financial information is protected with industry-leading encryption and security measures.
          </p>
        </div>
      </div>
    </section>
  );
}
